import request from "./../utils/request";

export function getCatalogContent() {
    return request({
        url: `/catalogContent/`,
        method: "get",
    });
}

export function createCatalogContent(data) {
    return request({
        url: "/catalogContent/",
        method: "post",
        data: data,
    });
}

export function updateCatalogContent(id, data) {
    return request.put(`/catalogContent/${id}`, data);
}

export function deleteCatalogContent(id) {
    return request.delete(`/catalogContent/${id}`);
}

export function getCatalogContentByParent(id) {
    return request.get(`/catalogContent/${id}`);
}
